import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';
import DoradoActionParameter, {
    SEARCH_ENTITY_TYPE,
    STRING_ENTITY_TYPE,
} from '../store/schema/DoradoActionParameter';

const DORADO_SEARCH_URL: string = 'ows/api/beta/CortanaRuntime';

export default async function executeDoradoRuntime(
    action: any,
    actionParameters: DoradoActionParameter[],
    correlationId: string
): Promise<any> {
    const requestBody = {
        entities: getBoundEntitiesFromActionParameters(actionParameters),
        action: action,
    };

    const response = await makePostRequest(DORADO_SEARCH_URL, requestBody, correlationId, true);
    if (isSuccessStatusCode(response.status)) {
        try {
            return response.json();
        } catch (error) {
            trace.warn('[executeDoradoRuntime] Exception: ' + error.message);
        }
    }

    return undefined;
}

function getBoundEntitiesFromActionParameters(actionParameters: DoradoActionParameter[]): any {
    const boundEntities = {};
    actionParameters.forEach(actionParameter => {
        const value = parseActionParameterToBoundEntity(actionParameter);
        if (value) {
            boundEntities[actionParameter.name] = value;
        }
    });
    return boundEntities;
}

function parseActionParameterToBoundEntity(actionParameter: DoradoActionParameter): any {
    if (actionParameter.type === SEARCH_ENTITY_TYPE) {
        const boundEntity = {
            query: actionParameter.value,
        };
        boundEntity['@'] = actionParameter.type;
        return boundEntity;
    } else if (actionParameter.type === STRING_ENTITY_TYPE) {
        return actionParameter.value;
    } else {
        return null;
    }
}
